<div class="lab-dialog alert-dialog">
  <div class="alert-dialog__body">
    <div class="alert-dialog__icon" *ngIf="data.for_which != 'drawer'">
      <mat-icon>help_outline</mat-icon>
    </div>
    <p class="alert-dialog__message" *ngIf="data.for_which != 'drawer'">{{data.message}}</p>
    <p class="alert-dialog__message alert-dialog__message--drawer" *ngIf="data.for_which == 'drawer'">{{data.message}}</p>
  </div>

  <div class="alert-dialog__actions">
    <ng-container *ngIf="data.for_which != 'drawer'">
      <button mat-stroked-button (click)="close(false)" *ngIf="showCancel" class="alert-btn alert-btn--cancel">Cancel</button>
      <button mat-flat-button (click)="save(true)" *ngIf="showCancel" class="alert-btn alert-btn--confirm">Confirm</button>
      <button mat-flat-button (click)="save(true)" *ngIf="!showCancel && !editSec" class="alert-btn alert-btn--confirm">Ok</button>
      <button mat-stroked-button (click)="close(false)" *ngIf="editSec" class="alert-btn alert-btn--cancel">No</button>
      <button mat-flat-button (click)="save(true)" *ngIf="editSec" class="alert-btn alert-btn--confirm">Yes</button>
    </ng-container>
    <ng-container *ngIf="data.for_which == 'drawer'">
      <button mat-flat-button (click)="save(true)" *ngIf="!showCancel && !editSec" class="alert-btn alert-btn--confirm alert-btn--drawer">Ok</button>
    </ng-container>
  </div>
</div>
